import {
	CheckRounded,
	InfoOutlined,
	WarningAmberRounded,
} from "@mui/icons-material";
import { IconChip } from "@/pages/sawlines/components/primitives";
import type { QualityStatus } from "@/pages/sawlines/utils/qualityCheckMeasurements";

const ICONS = {
	warning: { Icon: WarningAmberRounded, title: "Needs attention" },
	check: { Icon: CheckRounded, title: "In tolerance" },
	info: { Icon: InfoOutlined, title: "No tolerance to check against" },
};

// in tolerance = filled
export const QualityStatusChip = ({
	label,
	color,
	icon,
}: {
	label: string;
	color: string;
	icon?: QualityStatus["icon"];
}) => (
	<IconChip
		label={label}
		color={color}
		Icon={icon && ICONS[icon].Icon}
		title={icon && ICONS[icon].title}
		filled={icon === "check"}
	/>
);
